import { render, staticRenderFns } from "./AverageRates.vue?vue&type=template&id=516abc36&scoped=true&"
import script from "./AverageRates.vue?vue&type=script&lang=js&"
export * from "./AverageRates.vue?vue&type=script&lang=js&"
import style0 from "./AverageRates.vue?vue&type=style&index=0&id=516abc36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516abc36",
  null
  
)

export default component.exports